var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLoad40 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.875 14.293a1 1 0 0 1 1.414 0l10.182 10.182a1 1 0 0 1-1.414 1.414L14.875 15.707a1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M25.89 14.293a1 1 0 0 1 0 1.414L15.706 25.89a1 1 0 1 1-1.414-1.414l10.182-10.182a1 1 0 0 1 1.414 0",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19,
  fill: "none"
})));
export default SvgIcLoad40;